import React, { useState, useRef, useEffect } from "react";

export function MultiSelect({ label, options, value = [], onChange, placeholder = "Выберите..." }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Закрываем дропдаун при клике вне его
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleToggle = (optionValue) => {
    const newValue = value.includes(optionValue)
      ? value.filter(v => v !== optionValue)
      : [...value, optionValue];
    onChange(newValue);
  };

  const handleSelectAll = () => {
    if (value.length === options.length) {
      onChange([]);
    } else {
      onChange(options.map(opt => opt.value));
    }
  };

  const getDisplayText = () => {
    if (value.length === 0) return placeholder;
    if (value.length === options.length) return "Все выбраны";
    if (value.length === 1) {
      const selected = options.find(opt => opt.value === value[0]);
      return selected?.label || value[0];
    }
    return `Выбрано: ${value.length}`;
  };

  return (
    <div className="relative" ref={dropdownRef}>
      {label && (
        <label className="block text-sm font-medium mb-2">
          {label}
        </label>
      )}
      
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-3 py-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-xl text-left flex items-center justify-between hover:border-blue-500 dark:hover:border-blue-400 transition-colors"
      >
        <span className={value.length === 0 ? "text-gray-400 text-sm" : "text-sm"}>
          {getDisplayText()}
        </span>
        <svg
          className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {isOpen && (
        <div className="absolute z-50 w-full mt-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-xl shadow-lg max-h-80 overflow-y-auto">
          {/* Кнопка "Выбрать все" */}
          <div className="sticky top-0 bg-gray-50 dark:bg-gray-700 border-b border-gray-200 dark:border-gray-600">
            <button
              type="button"
              onClick={handleSelectAll}
              className="w-full px-3 py-2 text-left hover:bg-gray-100 dark:hover:bg-gray-600 font-medium text-blue-600 dark:text-blue-400 transition-colors text-sm"
            >
              {value.length === options.length ? '✓ Снять все' : 'Выбрать все'}
            </button>
          </div>

          {/* Список опций */}
          <div className="py-1">
            {options.map((option) => (
              <label
                key={option.value}
                className="flex items-center px-3 py-2 hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer transition-colors"
              >
                <input
                  type="checkbox"
                  checked={value.includes(option.value)}
                  onChange={() => handleToggle(option.value)}
                  className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600"
                />
                <span className="ml-3 text-sm">
                  {option.label}
                </span>
              </label>
            ))}
          </div>

          {options.length === 0 && (
            <div className="px-4 py-8 text-center text-gray-500 dark:text-gray-400">
              Нет доступных опций
            </div>
          )}
        </div>
      )}

      {value.length > 0 && (
        <div className="mt-2 text-sm text-blue-600 dark:text-blue-400">
          Выбрано: {value.length}
        </div>
      )}
    </div>
  );
}
